import { render } from "./buyrect.vue?vue&type=template&id=4b53f641&scoped=true"
import script from "./buyrect.vue?vue&type=script&lang=js"
export * from "./buyrect.vue?vue&type=script&lang=js"

import "./buyrect.vue?vue&type=style&index=0&id=4b53f641&scoped=true&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b53f641"]])

export default __exports__